<div class="modal-header justify-content-end">
  <div class="in-progress" *ngIf="indicators.loadingLanguages">SRT Generation - Fetching available languages <div class="spinner-bar"></div> in progress</div>
  <div class="in-progress" *ngIf="indicators.generating">SRT Generation <div class="spinner-bar"></div> in progress</div>
  <div class="in-progress" *ngIf="!indicators.generating && !indicators.loadingLanguages">SRT Generation</div>
  <button type="button" class="close" aria-label="Close" (click)="cancelProgress(null)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div *ngIf="!indicators.generating && !indicators.loadingLanguages">
    <label>Please select the language of the audio file:</label>
    <select name="languages" [(ngModel)]="transcribeLanguage" class="form-control language-selector">
      <option *ngFor="let option of languages"  value="{{ option.tag }}">{{ option.title }}</option>
    </select>

    <label class="translation-label">Please select the target language of the transcription:</label>
    <select name="languages" [(ngModel)]="targetLanguage" class="form-control language-selector">
      <option value="no-translation">No translation</option>
      <option *ngFor="let option of targetLanguages"  value="{{ option.tag }}">{{ option.title }}</option>
    </select>

    <div class="text-center">
      <button class="btn btn-primary btn-generate" (click)="generateAudioTranscription()">Start SRT Generation</button>
    </div>
  </div>

  <div class="progress-bar-wrapper" *ngIf="indicators.generating">
    <app-transcribe-progress-bar [progressWidth]="indicators.progress + '%'"></app-transcribe-progress-bar>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/transcribe/transcribe.component.html